import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, ViewEncapsulation} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AbstractWizardStepComponent, Wizard} from "../../../../../../../common/interfaces/wizard.interface";
import {Base} from "../../../../../../../common/interfaces/base.interfaces";
import {HelpersService} from "../../../../../../../common/services/helpers.service";
import {Api, ApiService} from "../../../../../../../common/services/api.service";
import {ToastService} from "../../../../../../../common/services/toast.service";
import {SpinnerService} from "../../../../../../../common/services/spinner.service";
import {map, startWith} from "rxjs/operators";
import {Warehouse} from "../../../../../../../common/interfaces/warehouse.interface";
import {Form} from "../../../../../../../common/interfaces/form.interface";
import {Observable} from "rxjs";
import ISelectOption = Form.ISelectOption;

@Component({
    selector: "section-partner-procedures-wizard-update-pallet-hub",
    templateUrl: "update-pallet-hub.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class PartnerProceduresWizardUpdatePalletHubComponent extends AbstractWizardStepComponent implements OnDestroy {

    private state: Base.IState;

    public available_hubs: { group: string, hubs: Warehouse.IHub[] }[];

    public old_hub: FormControl = new FormControl(null, [Validators.required]);

    public form: FormGroup = new FormGroup({
        inventory_conversion_id: new FormControl(null, [Validators.required]),
        pallets: new FormControl([], [Validators.required]),
        remark: new FormControl(null, [Validators.required]),
    });

    public palletSearch: FormControl = new FormControl(null);
    public pallets: ISelectOption[] = [];

    public errors: string[] = [];

    public constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        public helperService: HelpersService,
        private apiService: ApiService,
        private toastService: ToastService,
        private spinnerService: SpinnerService
    ) {
        super(changeDetectorRef);
    }

    /**
     * Submit form
     */
    public async submit(): Promise<any> {
        this.spinnerService.show();
        const {type, message}: Api.IResponse = await this.apiService.request(Api.EMethod.Put,
            ["inventory", "pallet-hub-change"], this.form.value);
        if (type as string === "success") {
            this.toastService.show(message, "success");
            this.form.reset({
                inventory_conversion_id: null,
                pallets: [],
                remark: null
            });

            this.changeDetectorRef.markForCheck();
        }
        this.spinnerService.hide();
    }

    /**
     * Add existing pallets on Enter.
     * In case of copy/paste multiple pallets in search field
     * @param event
     */
    public onKeydown(event: any): void {
        if (event.key === "Enter" && this.palletSearch.value !== "") {
            const values: string[] = this.palletSearch.value.split(/[\s,;]/);

            const pallets: string[] = this.form.value.pallets;

            for (const value of values) {
                if (value && value.trim() !== "") {
                    if (!pallets.map(b => b.toLowerCase()).includes(value.trim().toLowerCase())) {
                        pallets.push(value.trim());
                    }
                }
            }
            this.form.get("pallets").setValue(pallets);

            this.palletSearch.reset();
            this.changeDetectorRef.markForCheck();
        }
    }

    public removeChip(ref: string): void {
        const pallets: string[] = this.form.value.pallets;
        const index: number = pallets.indexOf(ref);

        if (index >= 0) {
            pallets.splice(index, 1);
            this.form.get("pallets").setValue(pallets);
        }
    }

    /**
     * Initialize step
     * @param data
     * @returns {Promise<any>}
     */
    public async init(data: Wizard.IData): Promise<any> {
        this.state = data.state;

        this.result.emit({
            action: "result",
            value: true
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
